import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-navigation-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-900 font-heading whitespace-nowrap">
                柠檬导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              柠檬导航是一款精心筛选、分类清晰的优质网站导航平台，汇聚海量实用网址资源，助您快速找到所需网站。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-8 h-8 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                aria-label="GitHub"
              >
                <i className="ri-github-line"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              网站分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                首页
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                网站收录
              </a>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                友情链接
              </a>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                隐私政策
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              联系我们
            </h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-1.5"></i>
                contact@lemonnav.cn
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-shield-check-line mr-1.5"></i>
                每天 9:00 - 18:00
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-map-pin-line mr-1.5"></i>
                北京市朝阳区
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 柠檬导航 - 精选优质网站导航平台 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-500">
            用心筛选每一个网站，为您提供纯净的上网导航体验
          </p>
        </div>
      </div>
    </footer>
  );
}